import { render } from "./CopyLinkCard.vue?vue&type=template&id=5d829fd6"
import script from "./CopyLinkCard.vue?vue&type=script&lang=js"
export * from "./CopyLinkCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__